import { HarmonyPackageSchema } from '@rhythmic/types'
import type { CollectionBuildRequestConfig } from '../CollectionRegistry/CollectionBuilder.types'

export const HARMONY_PACKAGE_TABLE = '"public"."harmonyPackages"'

export const HarmonyPackageConfig: CollectionBuildRequestConfig = {
  collectionType: 'electric',
  table: HARMONY_PACKAGE_TABLE,
  partitionKey: 'workspace_id',
  key: 'id',
  apiEndpoint: '/api/harmony-packages',
  where: {},
  schema: HarmonyPackageSchema,
}
